// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Field, reduxForm, submit} from 'redux-form'
import _ from 'lodash'

import {InputField} from '../../form'

import {updateMyProfile} from '../../../actions/userManagement'

import {AdminIconComponent} from '../../../media/icons/UserIconsComponent'
import PermIdentityIcon from '@material-ui/icons/PermIdentity'

import './index.css'

const DEBOUNCE_TIME = 1500
class MyPersonalInfo extends Component {

  getUserIcon = (role) => {
    let icons = {
      'Admin': <AdminIconComponent />,
      'User': <PermIdentityIcon />
    }

    return icons[role]
  }

  handleChange = () => {
    this.props.dispatch(submit('MyPersonalInfo'))
  }

  render () {
    const {handleSubmit, initialValues} = this.props

    return (
      <div className='my-personal-info'>
        <form className=' form my-personal-info-form ' onSubmit={handleSubmit}>
          <div className='row'>
            <div className='col-2 user-icon text-right'>
              {this.getUserIcon(initialValues.permissions)}
            </div>
            <div className='col-4'>
              <label className='description'>First Name</label>
              <Field
                name='firstName'
                type='text'
                component={InputField}
                onChange={_.debounce( () => this.handleChange(), DEBOUNCE_TIME)}
              />
            </div>
            <div className='col-4'>
              <label className='description'>Last Name</label>
              <Field
                name='lastName'
                type='text'
                component={InputField}
                onChange={_.debounce( () => this.handleChange(), DEBOUNCE_TIME)}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-4 offset-md-2'>
              <label className='row description'>Username</label>
              <div className='row'>
                {initialValues.username}
                <Field
                  name='userName'
                  type='hidden'
                  component={InputField}
                />
              </div>
            </div>
            <div className='col-4'>
              <label className='row description'>Last Signed In</label>
              <div className='row'>
                {initialValues.lastSignedIn}
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-4 offset-md-2'>
              <label className='row description'>Permissions</label>
              <div className='row'>
                {initialValues.permissions}
              </div>
            </div>
            <div className='col-4'>
              <label className='row description'>Account Status</label>
              <div className='row'>
                {initialValues.accountStatus}
              </div>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

function onSubmit (values, dispatch) {
  let role = values.permissions === 'Admin' ? 'TenantAdmin' : 'TenantUser'
  values.role = role
  dispatch(updateMyProfile(values, 'MyPersonalInfo'))
}

export function validate (values) {
  let ret = {}

  if (!values.firstName || !values.firstName.trim()) {
    ret = {...ret, firstName: 'First Name cannot be blank'}
  }

  if (!values.lastName || !values.lastName.trim()) {
    ret = {...ret, lastName: 'Last Name cannot be blank'}
  }

  return ret
}


connect(MyPersonalInfo)

export default reduxForm({
  form: 'MyPersonalInfo',
  onSubmit: onSubmit,
  validate: validate
})(MyPersonalInfo)

